/** @jsx h */
import { h, Component } from 'preact'

import ShareIcon from '../icons/Share'
import navigatorShare from '../../../utils/navigatorShare'
import t from '../../../utils/translate'

class ShareButton extends Component {
  share () {
    const { href, title, organization } = this.props
    const text = t('journeys.js.share.button', {
      title,
      organizationName: organization.name
    })
    navigatorShare(href, title, text)
  }

  render () {
    if (!navigator.share) {
      return null
    }

    return (
      <button
        type='button'
        class='JourneyHeader-share Action--circle'
        onClick={() => {
          this.share()
        }}
      >
        <ShareIcon />
      </button>
    )
  }
}

export default ShareButton
